<template>
  <section class="feature_slider_wrap border-top border-bottom pt-60 pb-60" :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
    
    <div class="feature_item">
       <h2 v-for="(item, index) in items"
        :key="index">
  <svg
    v-if="true"
    width="40"
    height="1em"
    viewBox="0 0 40 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="flex-shrink-0"
    style="display: inline;"
  >
    <rect width="39.9678" height="40.9678" fill="#E4002B"/>
    <circle cx="12.7821" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="36.4886"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="36.4886"  r="2.18495" fill="white"/>
  </svg><span v-if="true">&nbsp;</span>{{ item.title }}
</h2>

    </div>

    
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'CountSection',
  mixins: [ComponentMixin],

  data() {
    return {
    
    };
  },

  computed: {
    items() {
      return this.groupedVariables.items;
    },
  },

  mounted() {
   
  },

  

  methods: {
    
    },

   

  },
);
</script>
